module.exports = __webpack_public_path__ + "img/GraphLogo.ed8f710b.svg";